"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRest = exports.REQUIRED_KEYS = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var config_1 = require("../config");
var util_1 = require("../util");
var fetchable_1 = require("./fetchable");
var rest_error_1 = require("./rest.error");
var rest_user_1 = require("./rest.user");
exports.REQUIRED_KEYS = [
    'application.name',
    'application.url',
    'application.version'
];
var HEADER_CONTENT_JSON = 'application/json';
var IkeRest = /** @class */ (function () {
    function IkeRest(log, applicationName, baseUrl, applicationVersion, rayId) {
        this.errorListeners = {};
        this.Log = {
            create: this.bindAction('log.create')
        };
        this.Capture = {
            thumbnail: this.bindAction('capture.thumbnail'),
            composite: this.bindAction('collection.capture.composite'),
            measurement: this.bindAction('collection.capture.measurement'),
            brightness: this.bindAction('collection.capture.brightness'),
            crop: this.bindAction('collection.capture.crop')
        };
        this.Verify = {
            check: this.bindAction('verify.check'),
            checkEmail: this.bindAction('verify.check.email'),
            forceAcceptInvite: this.bindAction('verify.force.accept.invite')
        };
        this.User = {
            create: this.bindAction('user.create')
        };
        this.SSOUser = {
            create: this.bindAction('sso.user.create'),
            triggerResetPassword: this.bindAction('sso.reset.password'),
            selfMigrate: this.bindAction('sso.user.migrate')
        };
        this.Version = {
            check: this.bindAction('version.check'),
            data: this.bindAction('version.data')
        };
        this.appName = applicationName;
        this.baseUrl = baseUrl;
        this.version = applicationVersion;
        this.fetch = config_1.IkeConfigStore.fetch;
        this.log = log;
        this.requester = "".concat(this.appName, "-").concat(this.version);
        this.rayId = rayId;
    }
    IkeRest.create = function (config, opts) {
        return new IkeRest(opts.log, config.mustGetString('application.name'), config.getString('application.url.internal') || config.mustGetString('application.url'), config.mustGetString('application.version'), opts.rayId);
    };
    IkeRest.createStore = function () {
        return new IkeRest.FetchableStore();
    };
    IkeRest.prototype.bind = function (token) {
        return new rest_user_1.IkeRestUser(this, token);
    };
    IkeRest.prototype.bindAction = function (action) {
        var _this = this;
        return function (data) { return _this.action(action, data); };
    };
    IkeRest.prototype.authenticate = function (sso_id, token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, profile, userRest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = { sso_id: sso_id, token: token };
                        return [4 /*yield*/, this.action('authenticate', data, token)];
                    case 1:
                        profile = _a.sent();
                        userRest = this.bind(token);
                        userRest.me.init(profile);
                        return [2 /*return*/, userRest];
                }
            });
        });
    };
    IkeRest.prototype.onError = function (type, callback) {
        if (this.errorListeners[type] == null) {
            this.errorListeners[type] = [callback];
        }
        else {
            this.errorListeners[type].push(callback);
        }
    };
    IkeRest.prototype.action = function (path, data, sessionToken, departmentId) {
        if (sessionToken === void 0) { sessionToken = null; }
        if (departmentId === void 0) { departmentId = null; }
        return this._post(path, data, sessionToken, departmentId);
    };
    IkeRest.prototype.actionRaw = function (path, data, sessionToken, departmentId) {
        if (sessionToken === void 0) { sessionToken = null; }
        if (departmentId === void 0) { departmentId = null; }
        return this._raw(path, data, sessionToken, departmentId);
    };
    IkeRest.prototype.headers = function (sessionToken, departmentId) {
        var headers = {};
        headers[core_api_1.IkeRequestHeader.REQUESTER] = this.requester;
        headers[core_api_1.IkeRequestHeader.CONTENT_TYPE] = HEADER_CONTENT_JSON;
        if (sessionToken != null) {
            // TODO: Remove JWT check and bearer prefix check by ensuring sessionToken is correct elsewhere
            if ((0, util_1.isJWT)(sessionToken)) {
                // If this already has the bearer prefix, don't append it again
                var authHeader = /^Bearer .*/.test(sessionToken)
                    ? sessionToken
                    : "Bearer ".concat(sessionToken);
                headers[core_api_1.IkeRequestHeader.AUTHORIZATION] = authHeader;
            }
            else {
                headers[core_api_1.IkeRequestHeader.AUTHORIZATION] = "token ".concat(sessionToken);
            }
        }
        if (this.rayId) {
            headers[core_api_1.IkeRequestHeader.RAY_ID] = this.rayId;
        }
        if (departmentId) {
            headers[core_api_1.IkeRequestHeader.DEPARTMENT] = departmentId;
        }
        return headers;
    };
    IkeRest.prototype.path = function (path) {
        if (path.indexOf('/') === -1) {
            return this.baseUrl + '/v1/action/' + path;
        }
        return this.baseUrl + path;
    };
    IkeRest.prototype._raw = function (path, data, sessionToken, departmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body, method, headers, apiUrl, startTime, response, duration, responseId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = data || {};
                        method = 'POST';
                        headers = this.headers(sessionToken, departmentId);
                        apiUrl = this.path(path);
                        startTime = Date.now();
                        this.log.trace("CallStart - ".concat(path));
                        return [4 /*yield*/, this.fetch(apiUrl, { method: method, headers: headers, body: JSON.stringify(body) })];
                    case 1:
                        response = _a.sent();
                        duration = Date.now() - startTime;
                        responseId = response.headers.get(core_api_1.IkeRequestHeader.REQUEST_ID);
                        if (response.ok) {
                            this.log.info({ responseId: responseId, duration: duration, status: response.status }, "CallDone - ".concat(path));
                        }
                        else {
                            this.log.warn({ responseId: responseId, duration: duration, status: response.status }, "CallDone - ".concat(path));
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    IkeRest.prototype.handleError = function (response) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var json, requestError, requestErrorType, errorListeners, _i, errorListeners_1, listener;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateIsJson(response)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        requestError = new rest_error_1.IkeRequestError(response.status, json);
                        requestErrorType = rest_error_1.IkeRequestErrorChecker.getErrorType(requestError);
                        errorListeners = this.errorListeners[requestErrorType] || [];
                        for (_i = 0, errorListeners_1 = errorListeners; _i < errorListeners_1.length; _i++) {
                            listener = errorListeners_1[_i];
                            listener(requestError);
                        }
                        throw new rest_error_1.IkeRequestError(response.status, json);
                }
            });
        });
    };
    IkeRest.prototype.validateIsJson = function (response) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contentType, text;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contentType = response.headers.get(core_api_1.IkeRequestHeader.CONTENT_TYPE) || '';
                        if (!(contentType.indexOf(HEADER_CONTENT_JSON) === -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, response.text()];
                    case 1:
                        text = _a.sent();
                        throw new rest_error_1.IkeRequestError(response.status, { message: text });
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IkeRest.prototype._post = function (path, data, sessionToken, departmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._raw(path, data, sessionToken, departmentId)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.validateIsJson(response)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        res = _a.sent();
                        return [2 /*return*/, res];
                    case 4: return [2 /*return*/, this.handleError(response)];
                }
            });
        });
    };
    IkeRest.FetchableStore = fetchable_1.IkeFetchableStore;
    return IkeRest;
}());
exports.IkeRest = IkeRest;
//# sourceMappingURL=rest.js.map